<template>
  <div style="display: flex;flex-direction: column;height: 100%">
    <div><Menu/></div>
    <div style="flex: 1;">
          <router-view/>
    </div>
    <div style="background:#262626;text-align: center;color: white ;font-size: 12px;padding: 5px 10%;line-height: 22px">Copyright © 2020 湖南汇米巴商业管理有限公司 版权所有 湘ICP备17001593号-2 · [备]</div>
  </div>

  <el-backtop :bottom="80">
    <div
        style="
        height: 100%;
        width: 100%;
        background-color:#ff5000;
        box-shadow: var(--el-box-shadow-lighter);
        text-align: center;
        line-height: 40px;
        color: white;
        display: flex;
        justify-content: center;
        align-items: center;
      "
    >
      <el-icon><ArrowUpBold /></el-icon>
    </div>
  </el-backtop>
</template>
<script>
import Menu from '@/components/MenuManage.vue'
// import  Menu from '@/components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    Menu
  }
}
</script>
<style>
body,html,#app{
  margin: 0;
  height: 100%;
}
</style>